import Mention from '@tiptap/extension-mention';
import { Node as ProseMirrorNode } from '@tiptap/pm/model';
import { PluginKey } from '@tiptap/pm/state';
import { SuggestionOptions } from '@tiptap/suggestion';
import { base64 } from '../../../../../utils/base64/base64';
import { Datatype } from '../../../datatype/Datatype';
import { IReference } from '../../../references/IReference';

export function parseDataReference(data: string): IReference | null {
  try {
    return JSON.parse(base64.decode(data));
  } catch (e1) {
    try {
      return JSON.parse(data); // Fall back to unencoded data
    } catch (e2) {
      console.error(`[parseDataReference] Impossibile decodificare data-reference`, {data, e1, e2}); // prettier-ignore
      return null;
    }
  }
}

export function encodeDataReference(reference: IReference): string {
  return base64.encode(JSON.stringify(reference));
}

export interface ComputeExpressionReferenceOptions {
  HTMLAttributes: Record<string, any>;
  renderLabel: (props: {
    options: ComputeExpressionReferenceOptions;
    node: ProseMirrorNode;
  }) => string;
  suggestion: Omit<SuggestionOptions, 'editor'>;
}

export const ComputeExpressionReferencePluginKey = new PluginKey(
  'expressionReference',
);

export interface ComputeExpressionReferenceAttributes {
  label: string;
  id: string;
  type: Datatype;
  reference: IReference;
}

export const ComputeExpressionReferenceNode = Mention.extend({
  name: 'compute-expression-reference',
  addAttributes() {
    return {
      ...this.parent?.(),
      reference: {
        default: null,
        parseHTML: element => {
          const data = element.getAttribute('data-reference');
          if (!data) return null;
          return parseDataReference(data);
        },
        renderHTML: attributes => {
          if (!attributes.reference) return {};
          return {
            'data-reference': encodeDataReference(attributes.reference),
          };
        },
      },
    };
  },
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        // TODO Vedere se è possibile eliminare la classe e basarsi solo sui `data-type`.
        // Al momento non sembra essere gestito da styled-components, e tiptap
        // non ci fa aggiungere "dinamicamente" le classi.
        class: 'compute-expression-reference',
      },
    };
  },
});
